import React, { useState } from "react";
import { connect } from "react-redux";
import { createStore } from "devextreme-aspnet-data-nojquery";
import CrateSearchFormResult from "../maintabs/crates/CrateSearchFormResult";
import CratesSearchForm from "../maintabs/crates/CratesSearchForm";

const IMCaretsDetails = (props) => {
    const orderStatus = "0";
    const getDataUrl = "wm/TransactionManagement/GetImcrateDetails";
    
    const [dataSource, setDataSource] = useState(null);
    const [pageTitle, setPageTitle] = useState("Crates");
    const accessToken = props.oidc.user.access_token;

    const GetGridData = (accessToken, url, formFields) => {
        const resultData = createStore({
            key: "rowId",
            loadParams: {
                Warehouse: () => formFields.Warehouse,
                Location: () => formFields.Location,
                CrateNumber: () => formFields.CrateNumber,
                Description: () => formFields.Description,
            },
            loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });
        return resultData;
    };

    const searchData = (formFields) => {
        const resultData = GetGridData(accessToken, getDataUrl, formFields);
        setDataSource(resultData);
    };

    return (
        <div>
            <div className="row">
                <div className="col-md-12 main-page">
                    <div id="accordion">
                        <CratesSearchForm pageTitle={pageTitle} searchData={searchData} />
                        <CrateSearchFormResult data={dataSource} />
                    </div>
                </div>
            </div>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(IMCaretsDetails);
